import { get, post } from 'request/index'

export const userLogin = data => post('/account/login', data)

export const userLogout = () => get('/account/logout')

export const getLoginInfo = () => get('/account/info')

export const editAccount = data => post('/account/save', data)

export const getAccountList = params => get('/account/list', params)

export const setAccountStatus = data => post('/account/changeStatus', data)

export const changePassword = data => post('/account/changePassword', data)
